import type { TLoanOrBondFieldArrayName } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/loansAndBonds/types.ts';

export const LOANS_AND_BONDS_TABLE_MIN_WIDTH = 1360;
export const LOANS_AND_BONDS_DATE_COLUMN_INDEXES = [2, 3] as const;
export const LOANS_AND_BONDS_TABLE_HEADERS = [
  'Найменування кредитора',
  'Код ЄДРПОУ кредитора',
  'Дата отримання',
  'Дата погашення',
  'Код валюти',
  'Поточна сума, тис. од.',
  'Рядок балансу',
  'Прострочення заборгованості, тис. од.',
] as const;
export const LOANS_AND_BONDS_TABLE_COLUMN_WIDTHS = [
  '24%',
  '11%',
  '10%',
  '10%',
  '8%',
  '13%',
  '11%',
  '13%',
] as const;

export const LOANS_AND_BONDS_GROUPS: {
  name: TLoanOrBondFieldArrayName;
  title: string;
}[] = [
  { name: 'receivedLoans', title: 'Позики' },
  { name: 'bondLoans', title: 'Облігаційні позики' },
];
